<template>
    <div class="user-groups fh">
      <div class="setting-header v-center space-between px-5">
      <div class="setting-heading-box">
          <img class="btn-icon setting-icon" src="~@/assets/images/icons/check-list-icon.svg" alt="" width="15px" />
        <h1 class="setting-name">
          CheckList Templates
        </h1>
        <p class="setting-subscript">Standardized checklists used for inspections and task validation</p>
      </div>
        <div class="v-center">
          <div>
           <label for="">Sort By</label>
            <select v-model="selectedSort" class="sort" name="" id="">
              <option value="1">Latest</option>
              <option value="2">Oldest</option>
              <option value="3">Sort: A to Z</option>
              <option value="4">Sort: Z to A</option>
            </select>
          </div>
          <div class="input-group search m mx-3">
            <input
              v-model="searchKeyword"
              type="text"
              @input="updateOnSearch"
              placeholder="Search by name"
            />
          </div>
          <router-link to="/settings/checklist/builder/new" v-if="user.tenantLevelRole === 'ADMIN'">
              <button v-if="isTenantAdmin" class="btn btn-black"> + Add Template </button>
            </router-link>
        </div>
      </div>
      <div class="user-groups-container">
        <div class="fh center" v-if="loading">
          <loading-circle />
          </div>
        <div v-else-if="totalCount === 0" class="user-groups-no-form fh center">
          No CheckList
        </div>
        <div class="copy-dtx-table user-groups-table mt-3" v-else>
        <table v-if="checkList.length > 0">
          <thead>
            <tr>
              <th>Name</th>
              <th>Created</th>
              <th>Category</th>
              <!-- <th v-if="isTenantAdmin">Actions</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row) in checkList" :key="row.id" class="pointer"  @click="editChecklist(row.id)">
                <td class="elipsis-text user-group-name" v-overflow-tooltip="row.name">{{ row.name }}</td>
                <td class="audit-cell">
                  <span class="audit-name" v-overflow-tooltip>
                    {{ row?.template_created_by?.first_name +
                      " " +
                      row?.template_created_by?.last_name }}
                  </span>
                  <span class="audit-date">{{ row.created_on | genericFormatDate }}</span>
                </td>
                 <td>
                  <label class="label" :style="getStyle(row.form_type)">{{
                     row?.core_form_type.name
                  }}</label>
                </td>
                <!-- <td class="action-column"> -->
        <!-- <div class="action-icons">
            <img
              v-if="user.tenantLevelRole === 'ADMIN'"
              width="24"
              @click="editChecklist(row.id)"
              v-tooltip="`Edit Template`"
              class="pointer"
              src="~@/assets/images/pencil.svg"
              alt="" />
          </div> -->
       <!-- </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-footer space-between">
          <pagination class="mt-4" :length="totalCount" :pageNumber="pageNumber" :perPage="perPage"
            @selectPage="selectPage" v-if="totalCount>10"/>
                      <span class="pagination-footer-total mt-4"  v-if="checkList.length > 0">Total checklist templates : &nbsp; <b> {{ totalCount }}</b></span>

        </div>
      </div>
    </div>
  </template>

<script>
import { mapGetters } from 'vuex'
import { getFormChecklist } from '@/api'
import { timeStampToDateTime } from '@/filters/dateFilter.js'
import Pagination from '@/components/common/pagination2.vue'
import LoadingCircle from '@/components/common/loadingCircle.vue'
import { alert } from '@/plugins/notification'
import { debounce } from '@/utils/debounce'
import { genericFormatDate } from '@/utils/date'

export default {
  components: { Pagination, LoadingCircle },
  name: 'check-list',
  filters: {
    timeStampToDateTime,
    genericFormatDate
  },
  data: () => ({
    checkList: [],
    loading: false,
    searchKeyword: '',
    pageNumber: 1,
    perPage: 8,
    totalCount: 0,
    updateOnSearch: null,
    selectedSort: '1'
  }),
  computed: {
    ...mapGetters(['user', 'getUserById', 'isOnProjectLevel']),
    isTenantAdmin () {
      return (
        this.user.tenantLevelRole === 'ADMIN'
      )
    }
  },
  methods: {
    editChecklist (id) {
      this.$router.push(`/settings/checklist/${id}`)
    },
    getStyle (id) {
      switch (id) {
      case 15:
        return { color: '#b90606', backgroundColor: '#f8d3d3', border: '1px solid #f66460' }
      case 16:
        return { color: '#1a12d9', backgroundColor: 'rgb(135 176 233 / 40%)', border: '1px solid #7eaee6' }
      case 17:
        return { color: 'rgb(23 100 18)', backgroundColor: 'rgb(158 240 151 / 40%)' }
      case 18:
        return { color: '#860686', backgroundColor: '#f9c3f9' }
      }
    },
    gotoUserGroupDetail (id) {
      this.$router.push(`/settings/checklist/${id}`)
    },
    selectPage (page) {
      this.pageNumber = page
      this.getTemplates()
    },
    getUserTooltip (user) {
      return `${user.first_name} ${user.last_name}`
    },
    async getTemplates () {
      this.loading = true
      try {
        await getFormChecklist((this.pageNumber - 1) * this.perPage, this.perPage, true, this.searchKeyword, this.selectedSort).then((res) => {
          this.checkList = res.core_form_templates
          this.totalCount = res.core_form_templates_aggregate.aggregate.count
        })
      } catch (err) {
        alert('Unable to fetch form templates')
      } finally {
        this.loading = false
      }
    },
    closePreview () {
      this.selectedTemplate = {
        id: 0,
        open: false,
        loading: false,
        data: [],
        name: '',
        type: '',
        version: 0
      }
    },
    getFullName (user) {
      return `${user.first_name} ${user.last_name}`
    }
  },
  created () {
    this.updateOnSearch = debounce(() => {
      this.pageNumber = 1
      this.getTemplates()
    }, 500)
    this.getTemplates()
  },
  mounted () {
    this.getTemplates()
  },
  watch: {
    selectedSort (value) {
      if (value === '0') return 0
      else return this.getTemplates()
    }
  }
}
</script>

  <style lang="scss" scoped >
  .audit-cell {
    white-space: normal !important;
    line-height: 1.2;
  }
  .audit-name,
  .audit-date {
   display: block;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
  }
  .audit-name {
   font-size: var(--text-xs2);
   font-weight: 400;
   color: #111827;
  }
  .audit-date {
   margin-top: 4px;
   font-size: var(--text-xs);
   color: #6b7280;
  }
  .grey-text {
    color: grey;
    font-size: var(--text-s);
  }
  .sort {
    height: 2em;
    width: 10rem;
    margin: 0 5px 0 5px;
    font-size: var(--text-base);
    background-color: var(--brand-light-color);
    line-height: 1;
    border: 1px solid var(--brand-color);
    border-radius: 4px;
    padding: 4px 12px;
    }
    .label {
    font-size: var(--text-xs3);
    line-height: 1;
    border-radius: 14px;
    padding: 2px 7px;
    }
  .user-groups {
    &-table {
      height: calc(100% - 70px);
      overflow-y: auto;
    }
    .user-group-name {
       max-width: 80px;
    }
    .description {
        max-width: 60px;
    }
    &-container {
      height: calc(100% - 80px);
    }
    &-no-form {
      font-size: var(--text-2xl);
      color: var(--text-color);
    }
    &-group {
      overflow: auto;
      position: relative;
      & > div {
        & > div {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          & > div {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        }
      }
      &-header {
        background-color: var(--brand-color);
        position: sticky;
        top: 0;
        &-item {
          padding: 4px 10px;
          font-size: var(--text-base);
          font-weight: 600;
          color: var(--text-color);
        }
      }
      &-row {
        display: grid;
        grid-template-columns: 2fr 3fr 1fr 1fr 80px;
      }
      &-item {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        & > div {
          padding: 4px 10px;
          font-size: var(--text-base);
          color: var(--text-color);
        }
      }
    }
    &-preview {
      &-header {
        padding: 5px 10px;
        background: var(--brand-color);
        & > h3 {
          font-size: var(--text-base);
          font-weight: 600;
          color: var(--text-color);
        }
        & select {
          font-size: var(--text-xs1);
          background-color: var(--brand-light-color);
          line-height: 1;
          border: 1px solid rgba(0, 0, 0, 0.3);
          border-radius: 4px;
          padding: 2px 6px;
        }
      }
      &-body {
        height: calc(100% - 40px);
        padding: 10px;
        background: var(--bg-color);
        overflow-y: auto;
      }
    }
  }
  </style>
